const DefinedRouteAlias = {
    Rental: {
        label: 'Rental',
        url: '/rental',
        otherIncludeRouteName: ['BoatTypeInfo', 'RentalOrderHistory']
    },
    Moorage: {
        label: 'Moorage',
        url: '/moorage',
        otherIncludeRouteName: ['MoorageOrder', 'MoorageMap', 'MoorageSlips']
    },
    AppUser: {
        label: 'App Users',
        url: '/app-users',
        otherIncludeRouteName: []
    },
    /*Payments: {
        label: 'Payments',
        url: '#'
    },*/
    AdminUser: {
        label: 'Admin Users',
        url: '/users',
        otherIncludeRouteName: []
    }
}

export default DefinedRouteAlias
